import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import Navbar from './components/Navbar'
import Home from './pages/Home'
import Scanner from './pages/Scanner'
import Analytics from './pages/Analytics'
import AIChat from './pages/AIChat'
import Reports from './pages/Reports'
import Dashboard from './pages/Dashboard'
import HeatMapPage from './pages/HeatMapPage'
import Settings from './pages/Settings'
import Alerts from './pages/Alerts'
import Login from './pages/Login'
import Register from './pages/Register'
import LandingPage from './pages/LandingPage'
import UserManagement from './pages/UserManagement'

import { AuthProvider, useAuth } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth()
  if (loading) return <div className="flex items-center justify-center h-screen bg-[#F3F4F6]"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1E4D40]" /></div>
  return isAuthenticated ? children : <Navigate to="/landing" replace />
}

const AuthRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth()
  if (loading) return null
  return isAuthenticated ? <Navigate to="/" replace /> : children
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/landing" element={<AuthRoute><LandingPage /></AuthRoute>} />
      <Route path="/login" element={<AuthRoute><Login /></AuthRoute>} />
      <Route path="/register" element={<AuthRoute><Register /></AuthRoute>} />
      <Route path="/" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><Home /></div></></ProtectedRoute>} />
      <Route path="/scanner" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><Scanner /></div></></ProtectedRoute>} />
      <Route path="/analytics" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><Analytics /></div></></ProtectedRoute>} />
      <Route path="/heatmap" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><HeatMapPage /></div></></ProtectedRoute>} />
      <Route path="/ai-chat" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><AIChat /></div></></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><Reports /></div></></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><Dashboard /></div></></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><Settings /></div></></ProtectedRoute>} />
      <Route path="/alerts" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><Alerts /></div></></ProtectedRoute>} />
      <Route path="/users" element={<ProtectedRoute><><Navbar /><div className="pt-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-12"><UserManagement /></div></></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/landing" replace />} />
    </Routes>
  )
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-[#F3F4F6]">
            <Toaster position="top-right" toastOptions={{ duration: 4000, style: { borderRadius: '12px' } }} />
            <AppRoutes />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
